export function createEmitter() {
    const map = new Map();
    const on = (event, fn) => {
        const set = map.get(event) ?? new Set();
        set.add(fn);
        map.set(event, set);
    };
    const off = (event, fn) => {
        map.get(event)?.delete(fn);
    };
    const once = (event, fn) => {
        const wrap = (p) => {
            off(event, wrap);
            fn(p);
        };
        on(event, wrap);
    };
    const emit = (event, payload) => {
        for (const fn of map.get(event) ?? [])
            fn(payload);
    };
    return { on, once, off, removeListener: off, emit };
}
//# sourceMappingURL=emitter.js.map